export default __webpack_public_path__ + "static/media/require.a9a9b7c3.png";